module.exports = __webpack_public_path__ + "media/images/mobile/left-arrow-e01d525f08960ed0579fde92741fe58a.svg";